"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OTHER_OUTFLOWS_EXTERNAL_NAME = exports.OTHER_INFLOWS_EXTERNAL_NAME = void 0;
exports.OTHER_INFLOWS_EXTERNAL_NAME = "other_inflows";
exports.OTHER_OUTFLOWS_EXTERNAL_NAME = "other_outflows";
